module.exports = __webpack_public_path__ + "static/media/group_photo_2.83fd6974.jpg";